import Joi from 'joi';


export const VALIDATION_CONTRACTORS_LIST = {
    options: {allowUnknownBody: false},
    body: {
        name                                    : Joi.string(),
        type                                    : Joi.string(),
        city                                    : Joi.array().items(Joi.string()),
        country                                 : Joi.string(),
        district                                : Joi.string(),
        origination                             : Joi.string(),
        foundedYear                             : Joi.number(),
        typeOfCompany                           : Joi.string(),
        revenue                                 : Joi.number(),

        typeOfContractor                        : Joi.array().items(Joi.string()),
        typeOfConstruction                      : Joi.array().items(Joi.string()),
        typeOfProject                           : Joi.array().items(Joi.string()),
        typeOfBusiness                          : Joi.array().items(Joi.string()),
        subBusiness                             : Joi.array().items(Joi.string()),
        mainMarkets                             : Joi.array().items(Joi.string()),
        orderBy: Joi.string().valid('updatedAt','createdAt', "revenue").required(),
        orderType: Joi.string().valid('ASC','DESC').required(),
        filterFollow:Joi.boolean(),
        page:Joi.number().min(1),
    }
};


export const VALIDATION_CONTRACTORS_DETAIL_ONE = {
    options: {allowUnknownBody: false},
    params: {
        id: Joi.number().required()
    }
};


export const VALIDATION_CONTRACTORS_CREATE_PROJECT_EXPERIENCE = {
    options: {allowUnknownBody: false},
    body: {
        name                                    : Joi.string().min(5).required(),
        description                             : Joi.string().min(5),
        documents                               : Joi.array().items(Joi.object()),
        listVideos                              : Joi.array().items(Joi.string()),
        listImages                              : Joi.array().items(Joi.string()),
        projectType                             : Joi.string(),
        projectSubType                          : Joi.string(),
        workType                                : Joi.string(),
        address                                 : Joi.string().required(),
        village                                 : Joi.string(),
        district                                : Joi.string().required(),
        city                                    : Joi.string().required(),
        country                                 : Joi.string().required(),
        minBudget                               : Joi.number(),
        maxBudget                               : Joi.number(),
        investmentType                          : Joi.string(),
        minContructionArea                      : Joi.number(),
        maxContructionArea                      : Joi.number(),
        minLandArea                             : Joi.number(),
        maxLandArea                             : Joi.number(),
        totalFloorArea                          : Joi.number(),
        state                                   : Joi.string(),
        status                                  : Joi.string(),
        minStartTime                            : Joi.date(),
        maxStartTime                            : Joi.date(),
        minFinishTime                           : Joi.date(),
        maxFinishTime                           : Joi.date(),
        purpose                                 : Joi.string(),
    }
};


export const VALIDATION_CONTRACTORS_UPDATE_PROJECT_EXPERIENCE = {
    options: {allowUnknownBody: false},
    body: {
        id                                      : Joi.string().min(5).required(),
        name                                    : Joi.string().min(5),
        description                             : Joi.string(),
        documents                               : Joi.array().items(Joi.object()),
        listVideos                              : Joi.array().items(Joi.string()),
        listImages                              : Joi.array().items(Joi.string()),
        projectType                             : Joi.string(),
        projectSubType                          : Joi.string(),
        workType                                : Joi.string(),
        address                                 : Joi.string(),
        village                                 : Joi.string(),
        district                                : Joi.string(),
        city                                    : Joi.string(),
        country                                 : Joi.string(),
        minBudget                               : Joi.number(),
        maxBudget                               : Joi.number(),
        investmentType                          : Joi.string(),
        minContructionArea                      : Joi.number(),
        maxContructionArea                      : Joi.number(),
        minLandArea                             : Joi.number(),
        maxLandArea                             : Joi.number(),
        totalFloorArea                          : Joi.number(),
        state                                   : Joi.string(),
        status                                  : Joi.string(),
        minStartTime                            : Joi.date(),
        maxStartTime                            : Joi.date(),
        minFinishTime                           : Joi.date(),
        maxFinishTime                           : Joi.date(),
        purpose                                 : Joi.string(),


    }
};


export const VALIDATION_CONTRACTORS_CREATE = {
    options: {allowUnknownBody: false},
    body: {
      name: Joi.string().required(),
      type: Joi.string(),
      wallImage: Joi.string(),
      logo: Joi.string(),
      address: Joi.string().required(),
      city: Joi.string().required(),
      country: Joi.string().required(),
      district: Joi.string().required(),
      phone: Joi.string().required(),
      mobile: Joi.string(),
      fax: Joi.string(),
      website: Joi.string(),
      email: Joi.string(),
      taxCode: Joi.string().required(),
      origination: Joi.string(),
      foundedYear: Joi.number(),
      description: Joi.string(),
      typeOfCompany: Joi.string(),
      qualityManagement: Joi.string(),
      language: Joi.string(),
      numberOfEmployees: Joi.string().max(100),
      revenue: Joi.number(),
      unitRevenue: Joi.string(),
      price: Joi.number(),
      pricing: Joi.array().items(Joi.object()),
      unitPrice: Joi.string(),
      awards: Joi.array().items(Joi.string()),
      verifyDocuments: Joi.object(),

      listVideos: Joi.array().items(Joi.string()),
      documents: Joi.array().items(Joi.object()),
      finances: Joi.array().items(Joi.object()),
      imageFinances: Joi.array().items(Joi.string()),
      affiliations: Joi.array().items(Joi.object()),
      services: Joi.array().items(Joi.object()),

      industries: Joi.array().items(Joi.string()).required(),
      typeOfContractor: Joi.array().items(Joi.string()).required(),
      typeOfConstruction: Joi.array().items(Joi.string()).required(),
      typeOfProject: Joi.array().items(Joi.string()),
      typeOfBusiness: Joi.array().items(Joi.string()),
      subBusiness: Joi.array().items(Joi.string()),
      mainMarkets: Joi.array().items(Joi.string()),
    }
};


export const VALIDATION_CONTRACTORS_UPDATE = {
    options: {allowUnknownBody: false},
    params: {
      contractorId: Joi.string().required()
    },
    body: {
      // name: Joi.string(),
      type: Joi.string(),
      wallImage: Joi.string(),
      logo: Joi.string(),
      address: Joi.string(),
      city: Joi.string(),
      country: Joi.string(),
      district: Joi.string(),
      phone: Joi.string(),
      mobile: Joi.string(),
      fax: Joi.string(),
      website: Joi.string(),
      email: Joi.string(),
      // taxCode: Joi.string(),
      origination: Joi.string(),
      foundedYear: Joi.number(),
      description: Joi.string(),
      typeOfCompany: Joi.string(),
      qualityManagement: Joi.string(),
      language: Joi.string(),
      numberOfEmployees: Joi.string().max(100),
      revenue: Joi.number(),
      unitRevenue: Joi.string(),
      awards: Joi.array().items(Joi.string()),
      verifyDocuments: Joi.object(),
      price: Joi.number(),
      pricing: Joi.array().items(Joi.object()),
      listVideos: Joi.array().items(Joi.string()),
      documents: Joi.array().items(Joi.object()),
      finances: Joi.array().items(Joi.object()),
      imageFinances: Joi.array().items(Joi.string()),
      affiliations: Joi.array().items(Joi.object()),
      services: Joi.array().items(Joi.object()),

      industries: Joi.array().items(Joi.string()),
      typeOfContractor: Joi.array().items(Joi.string()),
      typeOfConstruction: Joi.array().items(Joi.string()),
      typeOfProject: Joi.array().items(Joi.string()),
      typeOfBusiness: Joi.array().items(Joi.string()),
      subBusiness: Joi.array().items(Joi.string()),
      mainMarkets: Joi.array().items(Joi.string()),
    }
};


export const VALIDATION_UPDATE_HOUSELINK_EVALUATION = {
    options: {allowUnknownBody: false},
    body: {
      id: Joi.string().required(),
      isVerifiedFinances: Joi.number().valid(0, 1).required(),
      isVerifiedLicense: Joi.number().valid(0, 1).required(),
      houselinkRanking: Joi.object(),
      totalRanking: Joi.number(),
      isHouseLinkMember: Joi.boolean(),
      houselinkAwards: Joi.array().items(Joi.object()),
    }
};


export const VALIDATION_APPROVED_CONTRACTOR = {
    options: {allowUnknownBody: false},
    body: {
        id                                      : Joi.string().required(),
        approved                                : Joi.number().valid(1).required()
    }
};


export const VALIDATION_ADMIN_LIST_CONTRACTORS = {
    options: {allowUnknownBody: false},
    body: {
        name                                    : Joi.string(),
        type                                    : Joi.string(),
        city                                    : Joi.array().items(Joi.string()),
        country                                 : Joi.string(),
        district                                : Joi.string(),
        origination                             : Joi.string(),
        foundedYear                             : Joi.number(),
        typeOfCompany                           : Joi.string(),
        revenue                                 : Joi.number(),
        approved                                : Joi.boolean(),

        typeOfContractor                        : Joi.array().items(Joi.string()),
        typeOfConstruction                      : Joi.array().items(Joi.string()),
        typeOfProject                           : Joi.array().items(Joi.string()),
        typeOfBusiness                          : Joi.array().items(Joi.string()),
        subBusiness                             : Joi.array().items(Joi.string()),
        mainMarkets                             : Joi.array().items(Joi.string()),
        orderBy: Joi.string().valid('updatedAt','createdAt', "revenue").required(),
        orderType: Joi.string().valid('ASC','DESC').required(),
        page: Joi.number().min(1),
    }
};

export const VALIDATION_DEACTIVE_CONTRACTOR = {
  options: {allowUnknownBody: false},
  body: {
    id: Joi.string().required()
  }
};



// WEBPACK FOOTER //
// ./src/services/contractor/Contractor.Validator.js